import {
    companyCodesEnablingUnknownAccountType,
    materialTypesForEnablingBlankAccountType,
    plantCodesForEnablingBlankAccountType,
    purchasingGroupCodesForEnablingBlankAccountType,
    purchasingGrpEnablingUnknownAccountType,
    supplierCodesForEnablingBlankAccountType,
} from './constants';
import {Config} from 'olympe';

/**
 * is enable the Blank account type based on Supplier code, Purchasing group and Plant
 * @param {number} supplierCode
 * @param {string} purchasingGroupValue
 * @param {string} plantValue
 * @param {string} materialType
 * @return {!boolean}
 */
export const isEnabledBlankAccountType = (supplierCode, purchasingGroupValue, plantValue, materialType) => {
    const env = Config.getParameter('ENV');

    const supplierCodeFormatted = supplierCode.toString().padStart(10, '0');
    return materialTypesForEnablingBlankAccountType.includes(materialType) && (
        (supplierCodesForEnablingBlankAccountType[env].includes(supplierCodeFormatted) && plantCodesForEnablingBlankAccountType[env].includes(plantValue)) ||
        (supplierCodesForEnablingBlankAccountType[env].includes(supplierCodeFormatted) && purchasingGroupCodesForEnablingBlankAccountType[env].includes(purchasingGroupValue))
    );
};

/**
 * @param {string} companyCode
 * @param {string} purchasingGrp
 * @param {string} wayOfBuying
 * @return {boolean}
 */
export const isEnabledUnknownAccountType = (companyCode, purchasingGrp, wayOfBuying) => {
    const env = Config.getParameter('ENV');

    return companyCodesEnablingUnknownAccountType[env].includes(companyCode) &&
        purchasingGrpEnablingUnknownAccountType[env].includes(purchasingGrp) &&
        wayOfBuying === 'FO';
};

/**
 * filtering accountTypeOptions regarding on isEnabledBlankAccountType. The Unknown label should be hidden
 * @param {Array<LabelValue>} options
 * @param {number} supplierCode
 * @param {string} companyCodeValue
 * @param {string} purchasingGroupValue
 * @param {string} plantValue
 * @param {string} materialType
 * @param {string} wayOfBuyingValue
 * @return {Array<LabelValue>}
 */
export const filterAccountTypeOptions = (options, supplierCode, companyCodeValue, purchasingGroupValue, plantValue, materialType, wayOfBuyingValue) => {
    const blankEnabled = isEnabledBlankAccountType(supplierCode, purchasingGroupValue, plantValue, materialType);
    const unknownEnabled = isEnabledUnknownAccountType(companyCodeValue, purchasingGroupValue, wayOfBuyingValue);

    return options.filter((opt) => {
        if (opt.value === '' && !blankEnabled) {
            return false;
        } else return !(opt.value === 'U' && !unknownEnabled);
    });
};
